// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-detail-column-item__title{margin:14px 0 3px 0;color:#777;font-weight:500;letter-spacing:.5px}", ""]);
// Exports
module.exports = exports;
